var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.value < 0.80 ? 'red' : _vm.value > 0.90 ? 'green' : 'yellow'},[_vm._v(" "+_vm._s(parseInt(_vm.value * 100))+"% ")])
}
var staticRenderFns = []

export { render, staticRenderFns }